/**
 * usePrograms.js — React Query hooks for the multi-program LMS.
 *
 * Endpoints:
 *   GET /programs              -> list of active programs
 *   GET /programs/{slug}       -> single program detail
 *
 * Used by:
 *   - Navbar (dropdown of active programs)
 *   - ProgramsPage (grid)
 *   - ProgramLandingPage (single program detail)
 */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/apiClient';

export const programsKeys = {
  list: () => ['programs', 'list'],
  detail: (slug) => ['programs', 'detail', slug],
};

export function usePrograms() {
  return useQuery({
    queryKey: programsKeys.list(),
    queryFn: async () => {
      const res = await apiClient.get('/programs');
      return res.data?.programs ?? [];
    },
    staleTime: 5 * 60 * 1000, // 5 dakika cache
  });
}

export function useProgram(slug) {
  return useQuery({
    queryKey: programsKeys.detail(slug),
    queryFn: async () => {
      const res = await apiClient.get(`/programs/${slug}`);
      return res.data;
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}
